import { Component, input } from '@angular/core';
import { IEventInfoResourcePropertyBm, IEventInfoResourceResponseBm } from '@outlook-addin/cue-http';
import { translation } from '@cue/translations';
import { cueExternalLink, cueArrowRight, cueClose, cueCheck, IconComponent } from '@cue/ui/icons';
import {
  AssignToPipe,
  AssignToTranslateKeyToPipe,
  PhotosToFilePipe,
  ResourceExternalUrlPipe,
} from '../../shared/pipes';
import { TranslocoPipe } from '@jsverse/transloco';
import { ResourceMapComponent } from '../resource-map/resource-map.component';
import { ImageComponent } from '@cue/images';
import { FileGalleryComponent } from '@cue/ui/file-gallery';
import { hasResourcePropertyValue } from '../../shared/utils/resource-property.utils';
import { WorkingHoursComponent } from '@cue/ui';

@Component({
  selector: 'addin-resource-detail',
  templateUrl: './resource-detail.component.html',
  styleUrls: ['./resource-detail.component.scss'],
  imports: [
    AssignToPipe,
    IconComponent,
    AssignToTranslateKeyToPipe,
    TranslocoPipe,
    ResourceExternalUrlPipe,
    ResourceMapComponent,
    FileGalleryComponent,
    PhotosToFilePipe,
    WorkingHoursComponent,
  ],
})
export class ResourceDetailComponent {
  ICONS = {
    cueExternalLink,
    cueArrowRight,
    cueClose,
    cueCheck,
  };

  currentImage = undefined;
  translation = translation;
  resource = input<IEventInfoResourceResponseBm>();
  newMapFile = input('');

  getSimpleFiltersByResourceTypeId(detail: IEventInfoResourceResponseBm) {
    return this.getFiltersFromNavigationDetail(detail).filter((x) => x.dataTypeId !== 5);
  }

  private getFiltersFromNavigationDetail(
    detail: IEventInfoResourceResponseBm
  ): { name: string; value: unknown; dataTypeId: number }[] {
    return detail.properties
      .map((property) => ({
        name: property.name,
        dataTypeId: property.dataTypeId,
        value: this.getValueFromProperty(property),
      }))
      .filter((property) => hasResourcePropertyValue(property.value));
  }

  private getValueFromProperty(property: IEventInfoResourcePropertyBm): unknown {
    switch (property.dataTypeId) {
      case 1: {
        return property.valueBoolean;
      }
      case 2: {
        return property.valueNumber;
      }
      case 3: {
        return property.valueDecimal;
      }
      case 4: {
        return property.valueText;
      }
      case 5: {
        return property.valueChoices;
      }
      default:
        return null;
    }
  }

  navigateToResourceDetailInAssist(url: string) {
    window.open(url, '_blank');
  }
}
